import React, { useState, useEffect } from 'react';
import './sponsorship.css';

function C2wSponsorship() {
  const slides = [
    {
      id: 1,
      image: '/assets/full%20stack/aquasense.jpeg',
      teamName: 'TEAM BYTESBUILDER (Aqua Sense)',
      achievement: 'Sponsored by Core2web | Water Management IoT',
      quote: '"Ensuring access to safe & healthy drinking water via real-time purification, automatic pH monitoring, SS plate stabilization & smart IoT control systems."',
      prize: 'Core2web Sponsored',
      event: 'Water Management',
      membersCount: 11,
      membersList: [
        'Sneha Suraj Shedge (Team Lead)',
        'Harshawardhan Dnyandeo Chavan',
        'Saurav Khandu Waghole',
        'Sushant Shailesh Yadav',
        'Sanket Kumkar',
        'Amruta Anil Chavan',
        'Shravani Chandrakant Rajpure',
        'Roshan Ashok Rajpure',
        'Sakshi Mithu Bodkhe',
        'Prakash Chimaji Shinde',
        'Sayali Gajanan Wankhade'
      ]
    },
    {
      id: 2,
      image: '/assets/full%20stack/Field%20Dynamics.jpg',
      teamName: 'Field Dynamics (CANARY)',
      achievement: 'Sponsored by Core2web | Industrial IoT',
      quote: '"Fully offline hazard-inspection system featuring ground rover, wearable ESP32 controller, LoRa RF telemetry & real-time FPV inspection for hazardous environments."',
      prize: 'Core2web Sponsored',
      event: 'Industrial IoT',
      membersCount: 10,
      membersList: [
        'Sahil Vijay Galande (Team Lead)',
        'Abdurehaman Usman Fakir',
        'Aashish Vijay Chamle',
        'Prajwal Santosh Mahajan',
        'Purushottam Ramesh Rewanwar',
        'Shravan Sudhir Bangale',
        'Shivtej Sopan Ghadage',
        'Harshad Suresh Bhagat',
        'Rahul Rakesh Patil',
        'Abhishek Uttamrao Rathod'
      ]
    },
    {
      id: 3,
      image: '/assets/full%20stack/Team%20Arjuna.jpeg',
      teamName: 'Team Arjuna (HastVani)',
      achievement: 'Sponsored by Core2web | Assistive Tech & Wearable IoT',
      quote: '"Super Gloves wearable assistive system converting sign language gestures into real-time speech, displaying text feedback & aiding visually impaired individuals in reading books."',
      prize: 'Core2web Sponsored',
      event: 'Assistive Tech',
      membersCount: 9,
      membersList: [
        'Rudraksh Kumbhar (Team Lead)',
        'Mahesh Wankhede',
        'Subodh Kale',
        'Poorva Shrikishan Saboo',
        'Surwase Ahilya Sangram',
        'Bedre Vaibhavi Subhash',
        'Pooja Somadev Survase',
        'Mauli Rajmane',
        'Diksha Jangam'
      ]
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-play interval
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <div className="C2wSponsorship_ctn">
      {/* Top Main Sponsorship Fold */}
      <div className="sponsorship-hero-fold">
        {/* Left Info Column */}
        <div className="sponsorship-info-col">
          <div className="sponsorship-pill-badge">
            <span className="pill-badge-icon">🌐</span>
            <span>Sponsorship</span>
          </div>
          <span className="sponsorship-sub-badge">We believe in Your Potential</span>
          <h2 className="sponsorship-main-title">
            Fueling Student Innovation<br />Beyond The Classroom
          </h2>
          <p className="sponsorship-desc">
            If your project deserves a bigger stage, Core2web helps you reach it with sponsorships, mentorship, and competition support.
          </p>
          <button className="sponsorship-cta-btn">
            Apply For Sponsorship <span className="arrow">→</span>
          </button>
          <div className="sponsorship-status">
            <span className="status-icon">✓</span>
            <span>Open for all Core2web students & alumni</span>
          </div>
        </div>

        {/* Right 3D Illustration Column */}
        <div className="sponsorship-graphic-col">
          <img
            src="/assets/images/gallery/sponsorship.png"
            alt="Student Innovation Sponsorship Illustration"
            className="sponsorship-illustration-img"
          />
        </div>
      </div>

      {/* Bottom Slider Section */}
      <div className="sponsorship-slider-section">
        <h3 className="slider-section-heading">Dreams We Sponsored. Victories They Earned.</h3>

        {/* Sliding Area */}
        <div className="slider-viewports-wrapper">
          <div
            className="slider-track-mover"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
          >
            {slides.map((slide) => (
              <div className="slider-item-card" key={slide.id}>
                {/* Image Part */}
                <div className="card-image-wrapper">
                  <img src={slide.image} alt={slide.teamName} />
                </div>

                {/* Info Part */}
                <div className="card-info-wrapper">
                  <h4 className="team-title">{slide.teamName}</h4>
                  <span className="achievement-subtitle">{slide.achievement}</span>
                  <p className="quote-text">{slide.quote}</p>
                  
                  {/* Badges */}
                  <div className="badges-row">
                    <div className="sponsorship-card-badge">
                      <span className="badge-bullet prize-bullet">✓</span>
                      <div className="badge-text-hld">
                        <span className="label">Status</span>
                        <span className="value">{slide.prize}</span>
                      </div>
                    </div>
                    <div className="sponsorship-card-badge">
                      <span className="badge-bullet event-bullet">✓</span>
                      <div className="badge-text-hld">
                        <span className="label">Category / Domain</span>
                        <span className="value">{slide.event}</span>
                      </div>
                    </div>
                    {slide.membersCount && (
                      <div className="sponsorship-card-badge">
                        <span className="badge-bullet prize-bullet" style={{ background: '#712ae2', color: '#fff' }}>👥</span>
                        <div className="badge-text-hld">
                          <span className="label">Team Strength</span>
                          <span className="value">{slide.membersCount} Members</span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Progress bar line slider indicator at the bottom */}
        <div className="slider-progress-track">
          <div
            className="slider-progress-active-line"
            style={{
              width: `${100 / slides.length}%`,
              transform: `translateX(${currentIndex * 100}%)`
            }}
          ></div>
        </div>
      </div>
    </div>
  );
}

export default C2wSponsorship;
